export default "__VITE_ASSET__DXjQiP2M__"